import { j as a } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as s } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const t = s((l, e) => /* @__PURE__ */ a.jsx(
  i,
  {
    ref: e,
    ...l,
    image: (o) => /* @__PURE__ */ a.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...o,
        children: [
          /* @__PURE__ */ a.jsx(
            "path",
            {
              fill: "#2D2926",
              d: "M12.549 18.166a.6.6 0 0 1 .749.399c1.329 4.366 5.312 7.547 10.12 7.547 1.562 0 3.038-.336 4.364-.94l.012-.005.012-.008a.6.6 0 0 1 .188-.089l.013-.003.013-.007a10.67 10.67 0 0 0 5.518-6.495.6.6 0 0 1 1.148.35 12 12 0 0 1-1.267 2.803l-.062.101 3.458 3.45a.6.6 0 1 1-.848.85l-3.311-3.304-.105.13a11.8 11.8 0 0 1-3.427 2.893l-.132.074 2.31 4.046a.6.6 0 0 1-1.042.595l-2.355-4.125-.121.05a11.7 11.7 0 0 1-3.799.821l-.143.007v4.722a.6.6 0 1 1-1.2 0v-4.74l-.138-.01a11.7 11.7 0 0 1-3.593-.858l-.122-.051-2.389 4.184a.6.6 0 1 1-1.042-.595l2.352-4.12-.13-.074a11.8 11.8 0 0 1-3.218-2.724l-.105-.127-3.213 3.206a.6.6 0 1 1-.848-.85l3.35-3.343-.063-.101a12 12 0 0 1-1.333-2.91.6.6 0 0 1 .399-.75"
            }
          ),
          /* @__PURE__ */ a.jsx(
            "path",
            {
              fill: "#2D2926",
              fillRule: "evenodd",
              d: "M12.505 18.022a.75.75 0 0 1 .936.5c1.311 4.305 5.239 7.44 9.977 7.44 1.54 0 2.995-.33 4.302-.926a.8.8 0 0 1 .234-.11 10.52 10.52 0 0 0 5.439-6.4l.001-.005.044-.143.014.004a.75.75 0 0 1 1.377.576 12.1 12.1 0 0 1-1.282 2.84l3.374 3.365a.75.75 0 0 1-1.06 1.062l-3.193-3.186a11.9 11.9 0 0 1-3.47 2.93l2.234 3.915a.75.75 0 1 1-1.302.744l-2.29-4.012a11.8 11.8 0 0 1-3.848.833v4.579a.75.75 0 1 1-1.5 0v-4.6a11.8 11.8 0 0 1-3.638-.87l-2.323 4.07a.75.75 0 1 1-1.303-.744l2.278-3.99a12 12 0 0 1-3.26-2.759l-3.096 3.09a.75.75 0 1 1-1.06-1.062l3.266-3.258a12.1 12.1 0 0 1-1.35-2.947.75.75 0 0 1 .5-.936m21.176.587a10.82 10.82 0 0 1-5.596 6.586l-.025.012-.027.008a.5.5 0 0 0-.141.067l-.023.015-.025.012a10.65 10.65 0 0 1-4.426.953c-4.877 0-8.916-3.227-10.264-7.653a.45.45 0 1 0-.86.262 11.8 11.8 0 0 0 1.315 2.874l.129.203-3.436 3.427a.45.45 0 1 0 .636.637l3.33-3.322.21.255a11.7 11.7 0 0 0 3.177 2.689l.26.149-2.426 4.25a.45.45 0 1 0 .781.446l2.454-4.3.245.102a11.5 11.5 0 0 0 3.546.847l.277.021v4.879a.45.45 0 1 0 .9 0v-4.865l.286-.014a11.5 11.5 0 0 0 3.75-.811l.243-.097 2.42 4.238a.45.45 0 0 0 .78-.446l-2.384-4.178.264-.148c1.304-.728 2.45-1.7 3.383-2.857l.21-.259 3.43 3.421a.45.45 0 1 0 .635-.637l-3.542-3.533.125-.202c.528-.857.95-1.786 1.25-2.77a.45.45 0 0 0-.86-.261",
              clipRule: "evenodd"
            }
          )
        ]
      }
    )
  }
));
t.displayName = "AgencyEyeClosedIcon";
export {
  t as AgencyEyeClosedIcon,
  t as default
};
//# sourceMappingURL=index.js.map
